module.exports = __webpack_public_path__ + "static/team12-10871591a30aae114dc163203bfa5fe1.jpg";